export const restrictionDimensionPair = {
  CAMPAIGN: ['CAMPAIGN'],
  MEDIA_TYPE: ['MEDIA_TYPE', 'CAMPAIGN', 'SPLIT'],
  LINE_ITEM: ['LINE_ITEM', 'MEDIA_TYPE', 'CAMPAIGN'],
  AUDIENCE: ['AUDIENCE', 'LINE_ITEM', 'MEDIA_TYPE', 'CAMPAIGN', 'SPLIT'],
  CREATIVE: ['CREATIVE', 'AUDIENCE', 'LINE_ITEM', 'MEDIA_TYPE', 'CAMPAIGN', 'SPLIT'],
  PUBLISHER: ['PUBLISHER', 'MEDIA_TYPE', 'CAMPAIGN', 'SPLIT'],
  SPLIT: ['SPLIT', 'CREATIVE', 'AUDIENCE', 'MEDIA_TYPE', 'CAMPAIGN', 'PUBLISHER'],
  COUNTRY: ['COUNTRY'],
  DEVICE_TYPE: ['DEVICE_TYPE'],
  STATE_REGION: ['STATE_REGION', 'COUNTRY'],
  CITY: ['CITY', 'STATE_REGION', 'COUNTRY'],
  MEDIA_OWNER: ['MEDIA_OWNER'],
  CONVERSION_SOURCE: ['CONVERSION_SOURCE'],
  CHANNEL: ['CHANNEL'],
  PIXEL_CATEGORY: ['PIXEL_CATEGORY'],
  PIXEL_SUBCATEGORY: ['PIXEL_SUBCATEGORY', 'PIXEL_CATEGORY'],
};

export const visibleSubcategories = ['LEADS', 'PAGE_VISITS'];
